import { render, staticRenderFns } from "./BoxOsModal.vue?vue&type=template&id=1b0894ac&scoped=true&"
import script from "./BoxOsModal.vue?vue&type=script&lang=js&"
export * from "./BoxOsModal.vue?vue&type=script&lang=js&"
import style0 from "./BoxOsModal.vue?vue&type=style&index=0&id=1b0894ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0894ac",
  null
  
)

export default component.exports